import { vue } from '@/main';

export default function () {
  return [
    // Date-only pickers: the table expands a picked range to full days
    // (start of the from-day → end of the until-day) before requesting.
    {
      key: 'creationTime',
      type: 'dateRange',
      props: { mode: 'date' }
    },
    {
      key: 'ftdTime',
      type: 'dateRange',
      props: { mode: 'date' }
    },

    { key: 'id' },
    { key: 'firstName' }, { key: 'lastName' }, { key: 'phone' }, { key: 'email' }, { key: 'account' }, { key: 'banner' },
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'buTypes',
      label: 'departments',
      type: 'department',
      props: {
        clearable: true,
        multiple: true
      }
    },

    {
      key: 'statusList',
      type: 'status',
      props: {}
    },
    {
      key: 'affiliateId',
      type: 'affiliate',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'representativeUserIds',
      type: 'user',
      props: {
        clearable: true,
        multiple: true,
        nullable: true
      }
    },
    {
      key: 'ftdOwnerIds',
      type: 'user',
      props: {
        clearable: true,
        multiple: true,
        nullable: true
      }
    },
    {
      key: 'online',
      type: 'checkbox'
    },
    {
      key: 'marginCall',
      type: 'checkbox'
    },
    {
      key: 'vip',
      type: 'checkbox'
    }
  ];
}
